import { useCurrentModule } from '../components';
import { eclipseServerData } from '../utils';
export const useLocaleAndGeo = () => {
  const module = useCurrentModule();
  const {
    locale: contextLocale,
    isQuickPayLightbox
  } = module.internals.useContext();
  const {
    data,
    isLoading
  } = module.SDK.eclipseOfferingApiClient.hooks.useFetchUserSessionContext({}, Boolean(isQuickPayLightbox));
  const {
    locale: serverLocale,
    geo: serverGeo
  } = eclipseServerData.get();
  if (!isQuickPayLightbox) {
    return {
      locale: serverLocale,
      geo: serverGeo,
      isLoading: false
    };
  }
  return {
    locale: contextLocale || serverLocale,
    geo: (data == null ? void 0 : data.geo) || serverGeo,
    isLoading
  };
};
//# sourceMappingURL=useLocaleAndGeo.js.map